import * as actions from '../actions/userAccountActions';

const initialState =  {
  myTokensBalance: 0,
  myEtherBalance: 0,
  inputTokensToPurchase: 1
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_MY_TOKEN_BALANCE:
      return {
        ...state,
        myTokensBalance: action.payload
      };
    case actions.SET_MY_ETHER_BALANCE:
      return {
        ...state,
        myEtherBalance: action.payload
      };
    case actions.SET_INPUT_TOKENS_TO_PURCHASE:
      return {
        ...state,
        inputTokensToPurchase: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/userAccountReducer.js